jQuery(document).ready(function($) {


    if ($('.lyg-slider').length < 1 || $('body.elementor-editor-active').length > 0) {
        return;
    }

    // var currentSlide = 1;
    // var totalSlides = $('.lyg-slider').length;

    //////////////
    // initialise
    //////////////

    $('.lyg-slider').wrapAll('<div class="lyg-slider-wrapper" />');
    $("<div class='lyg-slider-nav'></div>").insertBefore($('.lyg-slider')[0]);

    var timings = [];
    var totalTime = 0;
  
    $('.lyg-slider').each(function(i,el){

        // var screenWidth = $(window)[0].outerWidth;
        var active = i === 0 ? ' active' : '';

        $("<div class='slide-indicator" + active + "' data-id=" + (i + 1) + "></div>").appendTo($('.lyg-slider-nav'));

        // $(el).css({left: (screenWidth * i),top: 0,transform: 'translateX(100%)'});
        $(el).addClass('slide-' + (i + 1));

        /// make intervals
        if ($(el).attr('data-time')) {
            var customTime = parseInt($(el).attr('data-time'));
            timings.push(customTime);
            totalTime += customTime;
        } else {
            var defaultTime = 4000;
            timings.push(defaultTime); 
            totalTime += defaultTime;
        }

    });

    var runningTotal = 0;
    $(timings).each(function(i,time){
       
        setTimeout(function(){

           // 1. first time round do things 
            showElement(i);

            setInterval(function(){ 
             
                // 2. then set a loop 
                showElement(i);

            }, totalTime);

        },runningTotal);

        runningTotal += time;

    });

    ////////////////
    // timed funcs
    ////////////////

    function showElement(i) {
        
        if (!$('.lyg-slider')[i]) {
            return;
        }
        var el = $('.lyg-slider')[i];
        var indicators = $('body').find('.lyg-slider-nav .slide-indicator');

        // show slide
        $('.lyg-slider').removeClass('active');
        $(el).addClass('active');

        // highlight active slide indicator
        $(indicators).each(function(i,el){
            $(el).removeClass('active')
        });
        $(indicators[i]).addClass('active');

    }


});